import React from 'react';
import UserActivityLogPage from './components/UserActivityLogPage';
import ListOfInsuranceCompaniesPage from './components/ListOfInsuranceCompaniesPage';
import RegistryOfSuspensionReasonsPage from './components/RegistryOfSuspensionReasonsPage';
import NotificationTemplateRegistry from './components/NotificationTemplateRegistry';
import { menuAfterIcon, MenuAfterShowNew } from '../../utils/formatters';
import PresetLink from '../Application/components/PresetLink';

const routes = [
  {
    path: '/reference-information',
    name: 'menu.reference',
    icon: 'reference',
    customIcon: true,
    loginRequired: true,
    component: RegistryOfSuspensionReasonsPage,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/reference-information',
        name: 'menu.reference.common.reason',
        icon: 'reference',
        onlyComponent: true,
        component: RegistryOfSuspensionReasonsPage,
        afterContent: <MenuAfterShowNew />,
        MenuComponent: PresetLink,
        customIcon: true,
        loginRequired: true,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/reference-information/notification-template-registry',
        name: 'menu.reference.notification.templates',
        icon: 'reference',
        onlyComponent: true,
        component: NotificationTemplateRegistry,
        afterContent: <MenuAfterShowNew />,
        customIcon: true,
        loginRequired: true,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/reference-information/list-insurance-companies',
        name: 'menu.reference.insurance.companies',
        icon: 'reference',
        onlyComponent: true,
        component: ListOfInsuranceCompaniesPage,
        customIcon: true,
        loginRequired: true,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/reference-information/user-activity-log',
        name: 'menu.reference.user.action',
        icon: 'reference',
        onlyComponent: true,
        component: UserActivityLogPage,
        customIcon: true,
        loginRequired: true,
        weight: 2,
        permission: [],
        children: [],
      },
    ],
  },
];

export default routes;
